import React from "react"
import { DetailsForm } from "./components"
import { FormattedMessage } from "react-intl"

const ManageTeamPage = () => {
  return (
    <div className="settings">
      <div className="settings__wrapper">
        <p className="settings__title">
          <FormattedMessage id="common.yourDetails" />
        </p>
        <DetailsForm />
      </div>
    </div>
  )
}

export default ManageTeamPage
